import React from 'react';
import {
    injectIntl,
    intlShape
} from 'react-intl';
import PropTypes from 'prop-types';

import css from './index.scss';
import messages from '../../messages';

import { studentIcon } from '../../../../helpers/icon-dictionary';
import { privacySettingSaveRequestEnum } from '../../../../helpers/enums';

import SvgIcon from '../../../svg-icon/svg-icon';

const NameSettings = ({
    intl,
    preferences,
    getDefaultValue,
    onSelectHandler
}) => {
    /**
     * ENUMS
     */
    const { NAME_FORMAT } = privacySettingSaveRequestEnum;

    /**
     * VARIABLES
     */
    const studentName = 'studentName';
    const inputType = 'radio';

    /**
     * FUNCTIONS
     */
    const renderSelectors = () => {
        const nameOptions = preferences.find(a => a.type === NAME_FORMAT);
        const nameDefault = getDefaultValue(nameOptions, NAME_FORMAT);

        return nameOptions.availableOptions.map(option => (
            <div
                className={
                    option.value === nameDefault ?
                        `${css.checked} ${css.radioContainer}` :
                        `${css.radioContainer}`
                }
                key={option.value}
            >
                <input
                    checked={option.value === nameDefault}
                    id={option.value}
                    name={studentName}
                    onChange={onSelectHandler}
                    type={inputType}
                />
                <label htmlFor={option.value}>{option.text}</label>
            </div>
        ));
    };

    /**
     * RENDER
     */
    return (
        <div className={css.nameSettings}>
            <div className={css.nameSettings__header}>
                <div className={css.sectionIcon}>
                    <SvgIcon icon={studentIcon} />
                </div>
                <div className={css.sectionTitle}>
                    {intl.formatMessage(messages.studentNameDisplay)}
                </div>
            </div>
            <div className={css.nameSettings__content}>
                <div
                    className={css.nameSettingsLabel}
                    dangerouslySetInnerHTML={{ __html: intl.formatMessage(messages.studentNameDisplayText) }} // eslint-disable-line react/no-danger
                />
                <div className={css.nameSettingsRadio}>
                    {renderSelectors()}
                </div>
            </div>
        </div>
    );
};

NameSettings.propTypes = {
    /**
     * Manages the default values from input
     */
    getDefaultValue: PropTypes.func.isRequired,
    /**
     * Used to manage translations
     */
    intl: intlShape.isRequired,
    /**
     * Sets selected value to parent state property 'saveRequest'
     */
    onSelectHandler: PropTypes.func,
    /**
     * Returned value from init data call used to populate init values
     */
    preferences: PropTypes.array
};

export default injectIntl(NameSettings);



// WEBPACK FOOTER //
// ./app/components/privacy-settings/sub-components/name-settings/index.js